module.exports = __webpack_public_path__ + "img/person-studying-online.80d1be05.png";